import { StyleSheet } from 'react-native';

import { Fonts } from '@vfgroup-oneplatform/foundation/Components/Themes';

import cardShadow from '../../../../Common/Styles/cardShadow';

export default StyleSheet.create({
  containerStyle: theme => ({
    borderRadius: 6.2,
    paddingTop: 17,
    paddingHorizontal: 17,
    backgroundColor: theme.colors.cardBackgroundColor,
    marginBottom: 17.4,
    ...cardShadow,
  }),
  titleStyle: {
    fontSize: 16.6,
    lineHeight: 22.9,
    ...Fonts.type.bold,
    marginBottom: 16.5,
  },
  dateTextStyle: {
    fontFamily: Fonts.type.VodafoneLt,
    fontSize: 25,
    lineHeight: 31.2,
    marginBottom: 17,
  },
  rowContainerStyle: {
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  subtitleTextStyle: {
    fontSize: 25,
    lineHeight: 31.2,
    marginBottom: 17,
  },
  separator: theme => ({
    marginBottom: 25,
    borderBottomColor: theme.colors.borderColorThree,
    borderBottomWidth: 1,
  }),
});
